/**
 * pdf.js wrapper. Vite bundles the worker via the ?url import.
 */
import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';
import workerSrc from 'pdfjs-dist/build/pdf.worker.mjs?url';

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

const docCache = new WeakMap(); // File -> Promise<PDFDocument>

async function loadDoc(file) {
  if (docCache.has(file)) return docCache.get(file);
  const ab = await file.arrayBuffer();
  const promise = pdfjsLib.getDocument({ data: ab }).promise;
  docCache.set(file, promise);
  return promise;
}

export async function renderThumbnail(file, maxHeight = 70) {
  const doc = await loadDoc(file);
  const page = await doc.getPage(1);
  const viewport = page.getViewport({ scale: 1 });
  const scale = maxHeight / viewport.height;
  const scaled = page.getViewport({ scale });
  const canvas = document.createElement('canvas');
  canvas.width  = Math.ceil(scaled.width);
  canvas.height = Math.ceil(scaled.height);
  await page.render({ canvasContext: canvas.getContext('2d'), viewport: scaled }).promise;
  return canvas.toDataURL('image/png');
}

export async function renderPageToCanvas(file, pageNum, targetWidth) {
  const doc = await loadDoc(file);
  const page = await doc.getPage(pageNum);
  const viewport = page.getViewport({ scale: 1 });
  const scale = targetWidth / viewport.width;
  const scaled = page.getViewport({ scale });
  const canvas = document.createElement('canvas');
  canvas.width  = Math.ceil(scaled.width);
  canvas.height = Math.ceil(scaled.height);
  await page.render({ canvasContext: canvas.getContext('2d'), viewport: scaled }).promise;
  return canvas;
}

export async function getPageCount(file) {
  const doc = await loadDoc(file);
  return doc.numPages;
}
